<template>
  <div
    class="file-uploader"
    :class="{ uploaded: uploadedFile }"
    @click="triggerFileInput"
  >
    <input
      ref="fileInput"
      type="file"
      class="file-uploader__input"
      accept=".jpg,.jpeg,.png,.svg"
      @change="handleFileUpload"
    />
    <button class="file-uploader__button">
      <NuxtImg
        src="/img/icon_clip.svg"
        alt="clip icon"
        class="file-uploader__icon"
      />
      <span>
        {{ uploadedFile ? uploadedFile.name : "Прикрепить" }}
      </span>
    </button>
  </div>
</template>

<script setup>
const emit = defineEmits(["update:modelValue", "change"])

const fileInput = ref(null)
const uploadedFile = ref(null)
const handleFileUpload = (event) => {
  const file = event.target.files[0]
  uploadedFile.value = file
  emit("update:modelValue", file)
  emit("change", file)
}

const triggerFileInput = () => {
  fileInput.value.click()
}
</script>

<style lang="scss">
.file-uploader {
  height: 65px;
  max-width: 138px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: $white;
  border-radius: 6px;
  cursor: pointer;

  &.uploaded {
    background: rgb(232, 241, 234);
  }
  &__input {
    display: none;
  }

  &__button {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    border: none;
    background: none;

    span {
      max-width: 71px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -moz-box;
      -moz-box-orient: vertical;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      line-clamp: 1;
      box-orient: vertical;
    }
  }

  &__icon {
    width: 14px;
  }
}
</style>
